module.exports = __webpack_public_path__ + "static/img/4344_phase_function_Paper_PointsHejduk_Prediction.4142e85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4344_phase_function_Paper_PointsHejduk_Prediction.png
// module id = QVuy
// module chunks = 0